export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "en",
    "resource": {
      "Language": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Language"])},
      "Asia Pacific": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Asia Pacific"])}
    }
  })
}
